import { doc, Timestamp, updateDoc } from "firebase/firestore";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { AuthContext } from "../../../services/context/authContext/AuthContext";
import { db } from "../../../services/firebaseConfig";
import { pagination } from "../../../theme/theme";
import { ReactComponent as Triangle } from "../../../assets/images/svg/triangle.svg";
import CountryList from "../../../assets/json/states.json";

import Modal from "../../modal/Modal";
import Pagination from "../../pagination/Pagination";
import AdminListItem from "./AdminListItem";
import ListItem from "./ListItem";
import EditOrderModal from "../../modal/UpdateOrder/EditOrderModal";
import AddProductModal from "../../modal/UpdateOrder/AddProductItemModal";
import { set } from "react-hook-form";

const OrderHistoryList = (props) => {
  const { orders, isLoading } = props;

  const user = useContext(AuthContext);

  const [currentIndex, setCurrentIndex] = useState(-1);
  const [isLoadingItem, setIsLoadingItem] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isEditModalOpen, SetIsEditModalOpen] = useState(false);
  const [currentOrder, setCurrentOrder] = useState();
  const [updateOrderList, setUpdateOrderList] = useState(false);
  const [shipmentCost, setShipmentCost] = useState();
  const [customCutCost, setCustomCutCost] = useState();
  const [isCheckVisible, setIsCheckVisible] = useState(false);
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);

  const isAdmin = user?.role === "admin";
  const isAccountant = user?.role === "accountant";

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // END Pagination

  useEffect(() => {
    if (currentIndex !== -1) {
      if (orders.length !== 0) {
        const copyOrder = structuredClone(orders[currentIndex]);

        const firestoreTimestamp = new Timestamp(
          copyOrder.createdAt.seconds,
          copyOrder.createdAt.nanoseconds
        );

        copyOrder.createdAt = firestoreTimestamp;

        setCurrentOrder(copyOrder);
      } else {
        setCurrentOrder([]);
      }
    }
  }, [currentIndex, orders]);

  useEffect(() => {
    if (isOpen) {
      document.body.setAttribute("style", "overflow:hidden");
    }
    !isOpen && document.body.setAttribute("style", "overflow:unset");
  }, [isOpen]);

  // effect for list to be render after pagination change
  const currentOrderList = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    if (firstPageIndex >= orders.length) {
      return orders.slice(0, orders.length);
    } else {
      return orders.slice(firstPageIndex, lastPageIndex);
    }
  }, [currentPage, pageSize, orders, updateOrderList]);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  const openAddProductModalHandler = () => {
    setIsAddProductModalOpen(true);
    SetIsEditModalOpen(false);
  };
  const closeAddProductModalHandler = () => {
    setIsAddProductModalOpen(false);
    SetIsEditModalOpen(true);
  };
  const toggleEditOrderModal = () => {
    SetIsEditModalOpen(!isEditModalOpen);
    setShipmentCost(undefined);
    setCustomCutCost(undefined);
    const copyOrder = structuredClone(orders[currentIndex]);

    const firestoreTimestamp = new Timestamp(
      copyOrder.createdAt.seconds,
      copyOrder.createdAt.nanoseconds
    );

    copyOrder.createdAt = firestoreTimestamp;
    setCurrentOrder(copyOrder);
  };

  const editOrderToggleModal = () => {
    setIsOpen(!isOpen);
    SetIsEditModalOpen(true);
  };

  const updateOrderStatus = async (id) => {
    setIsLoadingItem({ ...isLoadingItem, [id]: true });

    await updateDoc(doc(db, "orders", id), {
      isPayed: true,
    });
    const orderIndex = orders.findIndex((order) => order.id === id);
    const order = orders[orderIndex];
    const updatedOrder = {
      ...order,
      isPayed: true,
    };
    orders[orderIndex] = updatedOrder;
    setIsLoadingItem({ ...isLoadingItem, [id]: false });
    setUpdateOrderList(!updateOrderList);
  };

  const onSelectOrdersAmountOnPage = (e) => {
    const pageSize = e.target.value;
    setPageSize(pageSize);
  };

  const onCompanyChangedHandler = (e) => {
    setCurrentOrder((prev) => {
      return {
        ...prev,
        company: e.target.value,
      };
    });
  };

  const handleHingeChange = (e) => {
    const updateProducts = e;
    const updatedOrder = {
      ...currentOrder,
      products: updateProducts,
    };

    setCurrentOrder(updatedOrder);
  };

  const calculateTotalPrice = (productsList, prev) => {
    const updatedProduct = productsList;

    let price = 0;

    for (let product of updatedProduct) {
      price = price + product.qty * product.price;
    }
    const totalWithoutSalesTax = price + prev.touchUpKit + prev.assembleFee;
    let salesTax = 0;

    if (prev.isTaxable && typeof prev.salesTax === "number") {
      if (
        prev.billingAddress.state === "Illinois" &&
        prev.billingAddress.city === "Chicago"
      ) {
        const ChicagoSalesTax = 10.25;

        salesTax = totalWithoutSalesTax * (ChicagoSalesTax / 100);
      } else {
        const currentOrderUsStateData = CountryList.filter(
          (usState) => usState.state === prev.billingAddress.state
        );
        const taxRate = currentOrderUsStateData[0].taxRate;
        salesTax = totalWithoutSalesTax * (taxRate / 100);
      }
    }

    const totalPprice =
      totalWithoutSalesTax +
      salesTax +
      (shipmentCost ?? 0) +
      (customCutCost ?? 0);

    return {
      ...prev,
      shipmentCost: shipmentCost ?? 0,
      customCutCost: customCutCost ?? 0,
      products: updatedProduct,
      salesTax: salesTax,
      subtotal: price,
      totalPrice: totalPprice,
    };
  };

  const handleAmountChange = (productsList) => {
    setCurrentOrder((prev) => {
      const result = calculateTotalPrice(productsList, prev);
      return result;
    });
  };

  const removeItemFromOrderListHandler = (productIndex) => {
    setCurrentOrder((prev) => {
      const productsList = prev.products.filter(
        (product, index) => index !== productIndex
      );
      const result = calculateTotalPrice(productsList, prev);
      return result;
    });
  };

  const addProductToOrderHandler = (product) => {
    setCurrentOrder((prev) => {
      const productsList = [...prev.products, product];
      const result = calculateTotalPrice(productsList, prev);
      return result;
    });
  };
  const addShipmentCostHandler = () => {
    setCurrentOrder((prev) => {
      const productsList = [...prev.products];
      const result = calculateTotalPrice(productsList, prev);
      return result;
    });
  };
  const addCustomCutCostHandler = () => {
    setCurrentOrder((prev) => {
      const productsList = [...prev.products];
      const result = calculateTotalPrice(productsList, prev);
      return result;
    });
  };
  const updateOrder = async () => {
    try {
      await updateDoc(doc(db, "orders", currentOrder.id), currentOrder);
      orders[currentIndex] = currentOrder;
      setUpdateOrderList(!updateOrderList);
      SetIsEditModalOpen(!isEditModalOpen);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="mt-20 ">
      {isAdmin || isAccountant ? (
        <div className="w-full hidden desktop:flex  desktop:text-xl xl:text-titleSize  p-5 xl:p-8 text-center items-center justify-between">
          <h2 className="w-30  desktop:text-xl xl:text-titleSize ">Number</h2>
          <h2 className="w-40 desktop:text-xl xl:text-titleSize ">Date</h2>
          <h2 className="w-52 desktop:text-xl xl:text-titleSize ">User</h2>
          <h2 className="w-60 desktop:text-xl xl:text-titleSize ">Company</h2>
          <h2 className="w-36 desktop:text-xl xl:text-titleSize ">Payment</h2>
          <div className="w-36 desktop:text-xl xl:text-titleSize " />
        </div>
      ) : (
        <div className="w-full hidden desktop:flex  desktop:text-xl xl:text-titleSize  p-5 xl:p-8 text-center items-center justify-between">
          <h2 className="w-30 xl:w-32 desktop:text-xl xl:text-titleSize">
            Number
          </h2>
          <div className="desktop:w-80 desktop:text-xl xl:text-titleSize" />
          <h2 className="w-32 desktop:text-xl xl:text-titleSize">Items</h2>
          <h2 className="w-36 desktop:text-xl xl:text-titleSize">Price</h2>
          <h2 className="w-36 desktop:text-xl xl:text-titleSize">Payment</h2>
          <h2 className="w-36 desktop:text-xl xl:text-titleSize">Delivery</h2>
        </div>
      )}
      <div className="flex flex-col gap-7">
        {orders.length ? (
          currentOrderList.map((item, index) => {
            return isAdmin || isAccountant ? (
              <AdminListItem
                setIsCheckVisible={(val) => setIsCheckVisible(val)}
                isCheckVisible={isCheckVisible}
                key={item.id}
                item={item}
                index={index}
                isLoading={isLoadingItem}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                toggleModal={toggleModal}
                updateOrder={() => updateOrderStatus(item.id)}
              />
            ) : (
              <ListItem
                key={item.id}
                item={item}
                index={index}
                setCurrentIndex={setCurrentIndex}
                toggleModal={toggleModal}
              />
            );
          })
        ) : isLoading ? (
          <div className="font-bold text-txtBlack text-center">loading...</div>
        ) : (
          <div className="font-bold text-txtBlack text-center">
            No orders found.
          </div>
        )}
      </div>

      <div className={pagination["selectOrdersAmountContainer"]}>
        <div style={{ width: "160px", height: "50px", position: "relative" }}>
          <select
            className={pagination["selectOrdersAmount"]}
            value={pageSize}
            onChange={onSelectOrdersAmountOnPage}
          >
            <option value={10}>{"10 orders"}</option>;
            <option value={15}>{"15 orders"}</option>;
            <option value={20}>{"20 orders"}</option>;
          </select>
          <Triangle className="relative pointer-events-none [left:140px] [bottom:30px]" />
        </div>
      </div>

      <Pagination
        currentPage={currentPage}
        totalCount={orders.length}
        pageSize={pageSize}
        onPageChange={(page) => setCurrentPage(page)}
      />
      {isOpen && (
        <Modal
          isAdmin={isAdmin}
          title="Order details"
          content="order"
          toggle={toggleModal}
          editOrderToggleModal={editOrderToggleModal}
          modalVisible={isOpen}
          products={orders}
          index={currentIndex}
        />
      )}
      {isEditModalOpen && (
        <EditOrderModal
          title="Edit order"
          content="edit order"
          toggle={toggleEditOrderModal}
          modalVisible={isEditModalOpen}
          currentOrder={currentOrder}
          companyChange={onCompanyChangedHandler}
          handleHingeChange={handleHingeChange}
          handleAmountChange={handleAmountChange}
          removeItemFromOrderListHandler={removeItemFromOrderListHandler}
          updateOrder={updateOrder}
          openAddProductModalHandler={openAddProductModalHandler}
          addShipmentCostHandler={addShipmentCostHandler}
          setShipmentCost={setShipmentCost}
          setCustomCutCost={setCustomCutCost}
          customCutCost={customCutCost}
          addCustomCutCostHandler={addCustomCutCostHandler}
          shipmentCost={shipmentCost}
        />
      )}
      {isAddProductModalOpen && (
        <AddProductModal
          title="Add new product to your order"
          modalVisible={isAddProductModalOpen}
          toggle={closeAddProductModalHandler}
          addProductToOrderHandler={addProductToOrderHandler}
        />
      )}
    </div>
  );
};

export default OrderHistoryList;
